"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("pageIframe").controller("pageIframeCtrl", pageIframeCtrl);

  function pageIframeCtrl($sce, CustomListsService, CustomersService, $rootScope, $scope, $timeout, $stateParams, ADMIN_URL, EXPORT_XLSX_URL, ApiService) {
    var vm = this;
    var iframeElement;

    vm.ctrlName = "pageIframeCtrl";

    vm.log = debug("pages:pageIframe");

    vm.refresh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var page, token, source, _token, customer, customerName, _source;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Remplace tous les "_" par des "/" pour reconstruire le chemin
              page = $stateParams.page.replace(/_/g, "/");

              if (!(page === "excel")) {
                _context.next = 9;
                break;
              }

              _context.next = 4;
              return ApiService.getToken(true);

            case 4:
              token = _context.sent;
              source = EXPORT_XLSX_URL + "/?customerId=" + $rootScope.$selectedCustomerId.replace("$", "") + "&token=" + token;


              vm.source = $sce.trustAsResourceUrl(source);
              _context.next = 21;
              break;

            case 9:
              _context.next = 11;
              return ApiService.getToken(true);

            case 11:
              _token = _context.sent;

              if (_token) {
                _context.next = 15;
                break;
              }

              $rootScope.$broadcast("auth_not_authenticated", "");
              return _context.abrupt("return");

            case 15:
              _context.next = 17;
              return CustomersService.getById($rootScope.$selectedCustomerId);

            case 17:
              customer = _context.sent;
              customerName = customer ? customer.name : "???";

              // Versionner le document embarqué évite que le DRM conserve une
              // ancienne version du module Pôle Clients et de son export Excel.

              _source = ADMIN_URL + "/?drmExportFormat=client-summary-v2#/" + page + "?fromDrm=true&customerId=" + $rootScope.$selectedCustomerId.replace("$", "") + "&customerName=" + customerName + "&token=" + _token;


              vm.source = $sce.trustAsResourceUrl(_source);

            case 21:

              $timeout(function () {
                iframeElement = document.querySelector("#myIframe");

                iFrameResize({
                  log: false,
                  checkOrigin: false,
                  // Some embedded screens use full-height grids. bodyOffset then
                  // reports only the viewport and cuts off the last rows/actions.
                  // "max" keeps the largest measured document height, while native
                  // iframe scrolling remains available as a safety net.
                  heightCalculationMethod: "max",
                  minHeight: Math.max(900, (window.innerHeight || 950) - 50),
                  scrolling: true
                }, "#myIframe");
              }, 0);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    $scope.$on("$destroy", function () {
      if (iframeElement && iframeElement.iFrameResizer) {
        iframeElement.iFrameResizer.close();
      }
      Notiflix.Loading.remove();
    });

    vm.refresh();
  }
})();